import { type FC } from "react";
import Modal from "@root/shared/components/Modal";
import { Button } from "@root/shared/components/Button";
import * as styles from "./styles.css";

type ConfirmBeforeActionModalProps = {
  isShow: boolean;
  title: string;
  description: string;
  notation?: string;
  cancelButtonText?: string; // 初期値: "キャンセル"
  confirmButtonText: string;
  onCancel: () => void;
  onConfirm: () => void;
};

export const ConfirmBeforeActionModal: FC<ConfirmBeforeActionModalProps> = ({
  isShow,
  title,
  description,
  notation,
  cancelButtonText = "キャンセル",
  confirmButtonText,
  onCancel,
  onConfirm,
}) => {
  return (
    <Modal
      isShow={isShow}
      spAppearanceType="center"
      pcWidthType="small"
      headerTitleStyle="none"
      footerContentStyle="button"
      onClose={onCancel}
      footerContent={
        // ボタンテキストがない場合からのボタンを表示することがないように
        // TODO: 呼び出し元での条件分岐で表示非表示を制御するようにする
        confirmButtonText && (
          <div className={styles.footerContent}>
            <Button theme="tertiary" onClick={onCancel}>
              {cancelButtonText}
            </Button>
            <Button theme="secondary" onClick={onConfirm}>
              {confirmButtonText}
            </Button>
          </div>
        )
      }
    >
      <div className={styles.contentsWrapper}>
        <b>{title}</b>
        {/* TODO: 呼び出し元での条件分岐で表示非表示を制御するようにする */}
        {confirmButtonText && <p className={styles.description}>{description}</p>}
        {notation && <p className={styles.notation}>{notation}</p>}
      </div>
    </Modal>
  );
};
